import React from "react";

import { Link } from "gatsby";

import { StaticImage } from "gatsby-plugin-image";
import "./Footer.scss";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <StaticImage
            src="../../images/star-logo.png"
            width={120}
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="S.T.A.R. Services Group logo"
            objectFit="contain"
            objectPosition="left center"
          />
        </div>
        <div className="footer-nav-group desktop-only">
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/history">History</Link>
            </li>
            <li>
              <Link to="/our-footprint">Our Footprint</Link>
            </li>
            <li>
              <Link to="/affiliate-companies">Affiliate Companies</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
          </ul>
        </div>
        <div className="footer-nav-group desktop-only">
          <h3>Services</h3>
          <ul>
            <li>
              <Link to="/our-services">Overview</Link>
            </li>
            <li>
              <Link to="/stevedoring-and-arrastre">Stevedoring & Arrastre</Link>
            </li>
            <li>
              <Link to="/loading">Loading</Link>
            </li>
            <li>
              <Link to="/transit-storage">Transit Storage</Link>
            </li>
            <li>
              <Link to="/cargo-delivery">Cargo Delivery</Link>
            </li>
            <li>
              <Link to="/terminal-management">
                Terminal Development & Management
              </Link>
            </li>
            <li>
              <Link to="/it-services">IT Services</Link>
            </li>
          </ul>
        </div>
        <div className="footer-nav-group desktop-only">
          <h3>Connect</h3>
          <ul>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <a
                href="https://sg-portal.aesi.io/login"
                target="_blank"
                rel="noreferrer"
              >
                Apollo Login
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-nav-group mobile-only">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/our-footprint">Our Footprint</Link>
            </li>
            <li>
              <Link to="/our-services">Our Services</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {year} S.T.A.R. Services Group. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
